import { useTranslation } from 'react-i18next';

const useTranslate = () => {
  const { t, i18n } = useTranslation();
  return {
    t: t,
    i18n: i18n,
  };
};

export default useTranslate;
